interface BandedValue {
  lower: number;
  higher: number;
}

export const formatToDecimalOrLeaveIntact = (val: number) =>
  Number.isInteger(val) ? val.toFixed(1) : val;

export const convertToRoundedFloatOrReturnOriginal = (
  input: string,
): string => {
  const normalizedInput = input.replace(/[-–]/g, '-');

  const num = parseFloat(normalizedInput);

  if (!Number.isNaN(num)) {
    const numStr = num.toFixed(1);

    if (normalizedInput.includes('-')) {
      const [start, end] = normalizedInput.split('-').map(parseFloat);
      if (!Number.isNaN(start) && !Number.isNaN(end)) {
        return `${start.toFixed(1)}-${end.toFixed(1)}`;
      }
    }

    if (normalizedInput.endsWith('+')) {
      return `${numStr}+`;
    }

    return numStr;
  }

  return input;
};

export const formatBandedValue = ({ higher, lower }: BandedValue): string => {
  if (higher === lower) {
    return `${higher}`;
  }
  if (higher > 0) {
    return `${lower}-${higher}`;
  }
  return `${lower}+`;
};

/**
 * Takes a BandedValue object and returns the formatted score.
 *
 * @param score A score object containing lower and higher.
 * @return string
 */
export const formatScore = (score: BandedValue) =>
  convertToRoundedFloatOrReturnOriginal(formatBandedValue(score));

/**
 * Takes a BandedValue object and returns a formatted rank.
 *
 * @param rank A rank object containing lower and higher values.
 * @param jointRanked Whether the rank is shared with another institution.
 * @return string
 */
export const formatRank = (rank: BandedValue, jointRanked = false) =>
  `${jointRanked ? '=' : ''}${formatBandedValue(rank)}`;

export const roundScore = (score: number, numberOfDecimalPlaces = 2) => {
  const scaleFactor = 10 ** numberOfDecimalPlaces;
  return Math.round(score * scaleFactor) / scaleFactor;
};
